import {
  Component,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { MdlDialogService } from './mdl-dialog.service';



export class MdlAlertComponent {

   public title: string;
   public message: string;
   public okText: string;


   public confirmed = new EventEmitter();

  constructor(private mdlDialogService: MdlDialogService) {
  }

  public show() {

    this.mdlDialogService.alert(this.message, this.okText, this.title).subscribe( () => {
      this.confirmed.emit();
    });

  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-alert',
  host: {
    '[style.display]': '"none"'
  },
  template: `
  `,
  exportAs: 'mdlAlert'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlDialogService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'title': [{ type: Input },],
'message': [{ type: Input },],
'okText': [{ type: Input },],
'confirmed': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
